import { render, staticRenderFns } from "./EditCheckpointCard.vue?vue&type=template&id=70fe2fa2"
import script from "./EditCheckpointCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCheckpointCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditCheckpointCard.vue?vue&type=style&index=0&id=70fe2fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports